import { useState } from 'react';

import { Box, Tabs, Text } from 'shell/components';

const options = [
    { key: 'tab-1', value: 'Tab 1', content: <Box>Tab 1 Content</Box>, disabled: false },
    { key: 'tab-2', value: 'Tab 2', content: <Box>Tab 2 Content</Box>, disabled: true },
    { key: 'tab-3', value: 'Tab 3', content: <Box>Tab 3 Content</Box> },
];

const TabsDemo = () => {
    const [tab, setTab] = useState(options[0].key);
    const [settingsTab, setSettingsTab] = useState('description');

    return (
        <>
            <Text variant={'sh1'}>Tabs</Text>
            <Tabs aria-label={'tabs example'} options={options} selected={tab} onChange={setTab} />
            <Text variant={'sh1'}>Assignment settings tabs</Text>
            <Tabs
                aria-label={'assignment settings tabs example'}
                appearance={'underline'}
                keepMounted
                options={[
                    {
                        key: 'description',
                        value: 'Description & Settings',
                        content: <input aria-label={'Draft example'} />,
                    },
                    { key: 'grading', value: 'Grading Settings', content: <Text>Grading settings</Text> },
                    { key: 'feedback', value: 'Feedback Settings', content: <Text>Feedback settings</Text> },
                ]}
                selected={settingsTab}
                onChange={setSettingsTab}
            />
        </>
    );
};

export default TabsDemo;
